import './contactUs.css';
import { FooterContent } from '../../graphql/pimcore/modules/siteContent/types/FooterContent';
import { Link } from 'react-router-dom';
import { LinkCollectionEntry } from '../../graphql/pimcore/modules/siteContent/types/SiteContentElement';
import { isLinkCollectionEntryInternal } from '../../graphql/pimcore/modules/siteContent/guards/SiteContentElement';

type ContactUsListProps = {
    cmsContent: FooterContent;
};

function LinkItem({ link }: { link: LinkCollectionEntry }) {
    return isLinkCollectionEntryInternal(link) ? (
        <Link className="a-styling" to={link.linkRoute}>
            {link.linkText}
        </Link>
    ) : (
        <a
            className="a-styling"
            href={link.linkUrl}
            target="_blank"
            rel="nofollow noopener noreferrer"
        >
            {link.linkText}
        </a>
    );
}

export default function ContactUsList({ cmsContent }: ContactUsListProps) {
    const { left: leftColumn, right: rightColumn } = cmsContent;
    return (
        <div className="ul-area">
            <ul className="ul-styling">
                <li>
                    <span className="header-styling">{leftColumn.title.content}</span>
                </li>
                {leftColumn.links.links.map((link, index) => (
                    <li key={index} style={{ marginTop: '0.6rem' }}>
                        <LinkItem link={link} />
                    </li>
                ))}
            </ul>
            <ul className="ul-styling2">
                <li>
                    <span className="header-styling">{rightColumn.title.content}</span>
                </li>
                {rightColumn.links.links.map((link, index) => (
                    <li key={index} style={{ marginTop: '0.6rem' }}>
                        <LinkItem link={link} />
                    </li>
                ))}
            </ul>
        </div>
    );
}
